(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@korzio/djv-draft-04"));
	else if(typeof define === 'function' && define.amd)
		define(["@korzio/djv-draft-04"], factory);
	else if(typeof exports === 'object')
		exports["djv"] = factory(require("@korzio/djv-draft-04"));
	else
		root["djv"] = factory(root["@korzio/djv-draft-04"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_29__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module utils
 * @description
 * Basic utilities for djv project
 */

/**
 * @name asExpression
 * @type {function}
 * @description
 * Transform function or string to expression
 * @see validators
 * @param {function|string} fn
 * @param {object} schema
 * @param {object} tpl templater instance
 * @returns {string} expression
 */
function asExpression(fn, schema, tpl) {
  if (typeof fn !== 'function') {
    return fn;
  }

  return fn(schema, tpl);
}

/**
 * @name hasProperty
 * @type {function}
 * @description
 * Check if the property exists in a given object
 * @param {object} object
 * @param {string} property
 * @returns {boolean} exists
 */
function hasProperty(object, property) {
  return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && Object.prototype.hasOwnProperty.call(object, property);
}

module.exports = {
  asExpression: asExpression,
  hasProperty: hasProperty
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @module schema
 * @description
 * Low-level utilities to check, create and transform schemas
 */

/**
 * @name transformation
 * @type {object}
 * @description
 * Schema values transformation
 */
var transformation = {
  ANY_SCHEMA: {},
  NOT_ANY_SCHEMA: { not: {} }
};

/**
 * @name is
 * @type {function}
 * @description
 * Verify the object could be a schema
 * Since draft-06 supports boolean as a schema definition
 * @param {object} schema
 * @returns {boolean} isSchema
 */
function is(schema) {
  return (typeof schema === 'undefined' ? 'undefined' : _typeof(schema)) === 'object' || typeof schema === 'boolean';
}

/**
 * @name transform
 * @type {function}
 * @description
 * Transform a schema pseudo presentation
 * Since draft-06 supports boolean as a schema definition
 * @param {object} schema
 * @returns {object} schema
 */
function transform(schema) {
  if (schema === true) {
    return transformation.ANY_SCHEMA;
  } else if (schema === false) {
    return transformation.NOT_ANY_SCHEMA;
  }
  return schema;
}

/**
 * @name make
 * @type {function}
 * @description
 * Generate a simple schema by a given object
 * @param {any} instance
 * @returns {object} schema
 */
function make(instance) {
  if ((typeof instance === 'undefined' ? 'undefined' : _typeof(instance)) !== 'object' || instance === null) {
    return { enum: [instance] };
  }

  if (Array.isArray(instance)) {
    return {
      items: instance.map(make),
      // other items should be valid by `false` schema, aka not exist at all
      additionalItems: false
    };
  }

  var required = Object.keys(instance);
  return {
    properties: required.reduce(function (memo, key) {
      return Object.assign({}, memo, _defineProperty({}, key, make(instance[key])));
    }, {}),
    required: required
    // other properties should be valid by `false` schema, aka not exist at all
    // additionalProperties: false,
  };
}

module.exports = {
  is: is,
  make: make,
  transform: transform,
  transformation: transformation
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * @module template
 * @description
 * Defines a small templater functionality for creating functions body.
 */

function sanitizeString(str) {
  if (typeof str !== 'string') {
    return str;
  }

  var sanitzedStr = String.prototype.replace.call(str, /[^a-z0-9áéíóúñü .,_-]/gim, '');
  return String.prototype.trim.call(sanitzedStr);
}

/**
 * @name template
 * @type function
 * @description
 * Provides a templater function, which adds a line of code into generated function body.
 *
 * @param {object} state - used in visit and reference method to iterate and find schemas.
 * @param {DjvConfig} options
 * @return {function} tpl
 */
function template(state, options) {
  function tpl(expression) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var last = void 0;

    tpl.lines.push(expression.replace(/%i/g, function () {
      return 'i';
    }).replace(/\$(\d)/g, function (match, index) {
      return '' + sanitizeString(args[index - 1]);
    }).replace(/(%[sd])/g, function () {
      if (args.length) {
        last = args.shift();
      }

      return '' + last;
    }));

    return tpl;
  }

  function clearDecode(tplString) {
    return tplString.replace('[', '').replace(']', '').replace('(', '').replace(')', '').replace('decodeURIComponent', '');
  }

  var error = typeof options.errorHandler === 'function' ? options.errorHandler : function defaultErrorHandler(errorType) {
    var path = this.data.toString().replace(/^data/, '');
    var dataPath = path.replace(/\['([^']+)'\]/ig, '.$1').replace(/\[(i[0-9]*)\]/ig, '[\'+$1+\']');
    var schemaPath = '#' + path.replace(/\[i([0-9]*)\]/ig, '/items').replace(/\['([^']+)'\]/ig, '/properties/$1') + '/' + errorType;

    return 'return {\n        keyword: \'' + errorType + '\',\n        dataPath: decodeURIComponent("' + clearDecode(dataPath) + '"),\n        schemaPath: decodeURIComponent("' + clearDecode(schemaPath) + '")\n      };';
  };

  Object.assign(tpl, {
    cachedIndex: 0,
    cached: [],
    cache: function cache(expression) {
      var layer = tpl.cached[tpl.cached.length - 1];
      if (layer[expression]) {
        return 'i' + layer[expression];
      }

      tpl.cachedIndex += 1;
      layer[expression] = tpl.cachedIndex;
      return '(i' + layer[expression] + ' = ' + expression + ')';
    },

    data: ['data'],
    error: error,
    lines: [],
    schema: ['schema'],
    push: tpl,
    /**
     * @name link
     * @description
     * Get schema validator by url
     * Call state link to generate or get cached function
     * @type {function}
     * @param {string} url
     * @return {string} functionName
     */
    link: function link(url) {
      return 'f' + state.link(url);
    },

    /**
     * @name visit
     * @description
     * Create new cache scope and visit given schema
     * @type {function}
     * @param {object} schema
     * @return {void}
     */
    visit: function visit(schema) {
      tpl.cached.push({});
      state.visit(schema, tpl);
      tpl.cached.pop();
    }
  });

  function dataToString() {
    return this.join('.').replace(/\.\[/g, '[');
  }
  tpl.data.toString = dataToString;
  tpl.schema.toString = dataToString;

  return tpl;
}

/**
 * @name restore
 * @type function
 * @description
 * Generate a function by given body with a schema in a closure
 *
 * @param {string} source - function inner & outer body
 * @param {object} schema - passed as argument to meta function
 * @param {DjvConfig} config
 * @return {function} tpl
 */
function restore(source, schema) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      inner = _ref.inner;

  /* eslint-disable no-new-func */
  var tpl = new Function('schema', source)(schema);
  /* eslint-enable no-new-func */

  if (!inner) {
    tpl.toString = function toString() {
      return source;
    };
  }

  return tpl;
}

/**
 * Configuration for template functions
 * @typedef {object} TemplateOptions
 * @property {string[]} context
 * @property {string[]} index
 * @property {boolean?} inner - a generating object should be considered as inner
 * @property {boolean?} defineErrors - if erros should be defined
 * @property {string[]} lines - content templates
 */

/**
 * @private
 * @name makeVariables
 * @type function
 * @description
 * Generate internal variables
 *
 * @param {TemplateOptions} options
 * @return {string} variables
 */
function makeVariables(_ref2) {
  var defineErrors = _ref2.defineErrors,
      index = _ref2.index;

  /**
   * @var {array} errors - empty array for pushing errors ability
   * @see errorHandler
   */
  var errors = defineErrors ? 'const errors = [];' : '';
  var variables = index ? 'let i' + Array.apply(undefined, _toConsumableArray(Array(index))).map(function (value, i) {
    return i + 1;
  }).join(',i') + ';' : '';

  // @see map array with holes trick
  // http://2ality.com/2013/11/initializing-arrays.html
  // TODO change var to const
  return '\n    ' + errors + '\n    ' + variables + '\n  ';
}

/**
 * @private
 * @name makeHelpers
 * @type function
 * @description
 * Generate internal helpers executed in outer function
 *
 * @param {TemplateOptions} options
 * @return {string} functions
 */
function makeHelpers(_ref3) {
  var context = _ref3.context,
      inner = _ref3.inner;

  if (inner || !context.length) {
    return '';
  }

  var functions = [];
  var references = [];

  context.forEach(function (value, i) {
    if (typeof value === 'number') {
      references.push(i + 1 + ' = f' + (value + 1));
      return;
    }
    functions.push(i + 1 + ' = ' + value);
  });

  return 'const f' + functions.concat(references).join(', f') + ';';
}

/**
 * @private
 * @name makeContent
 * @type function
 * @description
 * Generate internal function body content, including variables
 *
 * @param {TemplateOptions} options
 * @return {string} functions
 */
function makeContent(options) {
  var defineErrors = options.defineErrors,
      lines = options.lines;


  var variables = makeVariables(options);
  var errors = defineErrors ? 'if(errors.length) return errors;' : '';
  var content = lines.join('\n');

  return '\n    "use strict";\n    ' + variables + '\n    ' + content + '\n    ' + errors + '\n  ';
}

/**
 * @name body
 * @type function
 * @description
 * Generate a function body, containing internal variables and helpers
 *
 * @param {object} tpl - template instance, containing all analyzed schema related data
 * @param {object} state - state of schema generation
 * @param {DjvConfig} config
 * @return {string} body
 */
function body(_ref4, _ref5) {
  var cachedIndex = _ref4.cachedIndex,
      lines = _ref4.lines;
  var context = _ref5.context;

  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      inner = _ref6.inner,
      errorHandler = _ref6.errorHandler;

  var options = {
    context: context,
    inner: inner,
    defineErrors: errorHandler,
    index: cachedIndex,
    lines: lines
  };

  var helpers = makeHelpers(options);
  var content = makeContent(options);

  return '\n    ' + helpers + '\n    function f0(data) {\n      ' + content + '\n    }\n    return f0;\n  ';
}

/**
 * @name templateExpression
 * @type function
 * @description
 * Es6 template helper function
 * Transforms a validator utilities into generated functions body
 * @return {function} template
 */
function templateExpression(strings) {
  for (var _len2 = arguments.length, keys = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    keys[_key2 - 1] = arguments[_key2];
  }

  return function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    var dict = values[values.length - 1] || {};
    var result = [strings[0]];
    keys.forEach(function (key, i) {
      var value = Number.isInteger(key) ? values[key] : dict[key];
      result.push(value, strings[i + 1]);
    });
    return result.join('');
  };
}

module.exports = {
  body: body,
  restore: restore,
  template: template,
  expression: templateExpression
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _templateObject = _taggedTemplateLiteral(['!/^[a-zA-Z]+$/.test(', ')'], ['!/^[a-zA-Z]+$/.test(', ')']),
    _templateObject2 = _taggedTemplateLiteral(['!/^[a-zA-Z0-9]+$/.test(', ')'], ['!/^[a-zA-Z0-9]+$/.test(', ')']),
    _templateObject3 = _taggedTemplateLiteral(['!/^[-_a-zA-Z0-9]+$/.test(', ')'], ['!/^[-_a-zA-Z0-9]+$/.test(', ')']),
    _templateObject4 = _taggedTemplateLiteral(['!/^[a-fA-F0-9]+$/.test(', ')'], ['!/^[a-fA-F0-9]+$/.test(', ')']),
    _templateObject5 = _taggedTemplateLiteral(['!/^[0-9]+$/.test(', ')'], ['!/^[0-9]+$/.test(', ')']),
    _templateObject6 = _taggedTemplateLiteral(['isNaN(Date.parse(', ')) || ~', '.indexOf(\'/\')'], ['isNaN(Date.parse(', ')) || ~', '.indexOf(\\\'/\\\')']),
    _templateObject7 = _taggedTemplateLiteral(['', ' !== ', '.toUpperCase()'], ['', ' !== ', '.toUpperCase()']),
    _templateObject8 = _taggedTemplateLiteral(['', ' !== ', '.toLowerCase()'], ['', ' !== ', '.toLowerCase()']),
    _templateObject9 = _taggedTemplateLiteral(['', '.length >= 256 || !/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])(\\.([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9]))*$/.test(', ')'], ['', '.length >= 256 || !/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\\\-]{0,61}[a-zA-Z0-9])(\\\\.([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\\\-]{0,61}[a-zA-Z0-9]))*$/.test(', ')']),
    _templateObject10 = _taggedTemplateLiteral(['!/^[A-Za-z][A-Za-z0-9+\\-.]*:(?:\\/\\/(?:(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:]|%[0-9A-Fa-f]{2})*@)?(?:\\[(?:(?:(?:(?:[0-9A-Fa-f]{1,4}:){6}|::(?:[0-9A-Fa-f]{1,4}:){5}|(?:[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){4}|(?:(?:[0-9A-Fa-f]{1,4}:){0,1}[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){3}|(?:(?:[0-9A-Fa-f]{1,4}:){0,2}[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){2}|(?:(?:[0-9A-Fa-f]{1,4}:){0,3}[0-9A-Fa-f]{1,4})?::[0-9A-Fa-f]{1,4}:|(?:(?:[0-9A-Fa-f]{1,4}:){0,4}[0-9A-Fa-f]{1,4})?::)(?:[0-9A-Fa-f]{1,4}:[0-9A-Fa-f]{1,4}|(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))|(?:(?:[0-9A-Fa-f]{1,4}:){0,5}[0-9A-Fa-f]{1,4})?::[0-9A-Fa-f]{1,4}|(?:(?:[0-9A-Fa-f]{1,4}:){0,6}[0-9A-Fa-f]{1,4})?::)|[Vv][0-9A-Fa-f]+\\.[A-Za-z0-9\\-._~!$&\'()*+,;=:]+)\\]|(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|(?:[A-Za-z0-9\\-._~!$&\'()*+,;=]|%[0-9A-Fa-f]{2})*)(?::[0-9]*)?(?:\\/(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*|\\/(?:(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@]|%[0-9A-Fa-f]{2})+(?:\\/(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*)?|(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@]|%[0-9A-Fa-f]{2})+(?:\\/(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*|)(?:\\?(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@\\/?]|%[0-9A-Fa-f]{2})*)?(?:\\#(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@\\/?]|%[0-9A-Fa-f]{2})*)?$/.test(', ')'], ['!/^[A-Za-z][A-Za-z0-9+\\\\-.]*:(?:\\\\/\\\\/(?:(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:]|%[0-9A-Fa-f]{2})*@)?(?:\\\\[(?:(?:(?:(?:[0-9A-Fa-f]{1,4}:){6}|::(?:[0-9A-Fa-f]{1,4}:){5}|(?:[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){4}|(?:(?:[0-9A-Fa-f]{1,4}:){0,1}[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){3}|(?:(?:[0-9A-Fa-f]{1,4}:){0,2}[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){2}|(?:(?:[0-9A-Fa-f]{1,4}:){0,3}[0-9A-Fa-f]{1,4})?::[0-9A-Fa-f]{1,4}:|(?:(?:[0-9A-Fa-f]{1,4}:){0,4}[0-9A-Fa-f]{1,4})?::)(?:[0-9A-Fa-f]{1,4}:[0-9A-Fa-f]{1,4}|(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))|(?:(?:[0-9A-Fa-f]{1,4}:){0,5}[0-9A-Fa-f]{1,4})?::[0-9A-Fa-f]{1,4}|(?:(?:[0-9A-Fa-f]{1,4}:){0,6}[0-9A-Fa-f]{1,4})?::)|[Vv][0-9A-Fa-f]+\\\\.[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:]+)\\\\]|(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=]|%[0-9A-Fa-f]{2})*)(?::[0-9]*)?(?:\\\\/(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*|\\\\/(?:(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@]|%[0-9A-Fa-f]{2})+(?:\\\\/(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*)?|(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@]|%[0-9A-Fa-f]{2})+(?:\\\\/(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*|)(?:\\\\?(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@\\\\/?]|%[0-9A-Fa-f]{2})*)?(?:\\\\#(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@\\\\/?]|%[0-9A-Fa-f]{2})*)?$/.test(', ')']),
    _templateObject11 = _taggedTemplateLiteral(['!/^[^@]+@[^@]+\\.[^@]+$/.test(', ')'], ['!/^[^@]+@[^@]+\\\\.[^@]+$/.test(', ')']),
    _templateObject12 = _taggedTemplateLiteral(['!/^(\\d?\\d?\\d){0,255}\\.(\\d?\\d?\\d){0,255}\\.(\\d?\\d?\\d){0,255}\\.(\\d?\\d?\\d){0,255}$/.test(', ') || ', '.split(".")[3] > 255'], ['!/^(\\\\d?\\\\d?\\\\d){0,255}\\\\.(\\\\d?\\\\d?\\\\d){0,255}\\\\.(\\\\d?\\\\d?\\\\d){0,255}\\\\.(\\\\d?\\\\d?\\\\d){0,255}$/.test(', ') || ', '.split(".")[3] > 255']),
    _templateObject13 = _taggedTemplateLiteral(['!/^((?=.*::)(?!.*::.+::)(::)?([\\dA-F]{1,4}:(:|\\b)|){5}|([\\dA-F]{1,4}:){6})((([\\dA-F]{1,4}((?!\\3)::|:\\b|$))|(?!\\2\\3)){2}|(((2[0-4]|1\\d|[1-9])?\\d|25[0-5])\\.?\\b){4})$/.test(', ')'], ['!/^((?=.*::)(?!.*::.+::)(::)?([\\\\dA-F]{1,4}:(:|\\\\b)|){5}|([\\\\dA-F]{1,4}:){6})((([\\\\dA-F]{1,4}((?!\\\\3)::|:\\\\b|$))|(?!\\\\2\\\\3)){2}|(((2[0-4]|1\\\\d|[1-9])?\\\\d|25[0-5])\\\\.?\\\\b){4})$/.test(', ')']),
    _templateObject14 = _taggedTemplateLiteral(['/[^\\\\]\\\\[^.*+?^${}()|[\\]\\\\bBcdDfnrsStvwWxu0-9]/i.test(', ')'], ['/[^\\\\\\\\]\\\\\\\\[^.*+?^\\${}()|[\\\\]\\\\\\\\bBcdDfnrsStvwWxu0-9]/i.test(', ')']),
    _templateObject15 = _taggedTemplateLiteral(['!/^$|^\\/(?:~(?=[01])|[^~])*$/i.test(', ')'], ['!/^$|^\\\\/(?:~(?=[01])|[^~])*$/i.test(', ')']),
    _templateObject16 = _taggedTemplateLiteral(['!/^(?:[A-Za-z][A-Za-z0-9+\\-.]*:(?:\\/\\/(?:(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:]|%[0-9A-Fa-f]{2})*@)?(?:\\[(?:(?:(?:(?:[0-9A-Fa-f]{1,4}:){6}|::(?:[0-9A-Fa-f]{1,4}:){5}|(?:[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){4}|(?:(?:[0-9A-Fa-f]{1,4}:){0,1}[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){3}|(?:(?:[0-9A-Fa-f]{1,4}:){0,2}[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){2}|(?:(?:[0-9A-Fa-f]{1,4}:){0,3}[0-9A-Fa-f]{1,4})?::[0-9A-Fa-f]{1,4}:|(?:(?:[0-9A-Fa-f]{1,4}:){0,4}[0-9A-Fa-f]{1,4})?::)(?:[0-9A-Fa-f]{1,4}:[0-9A-Fa-f]{1,4}|(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))|(?:(?:[0-9A-Fa-f]{1,4}:){0,5}[0-9A-Fa-f]{1,4})?::[0-9A-Fa-f]{1,4}|(?:(?:[0-9A-Fa-f]{1,4}:){0,6}[0-9A-Fa-f]{1,4})?::)|[Vv][0-9A-Fa-f]+\\.[A-Za-z0-9\\-._~!$&\'()*+,;=:]+)\\]|(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|(?:[A-Za-z0-9\\-._~!$&\'()*+,;=]|%[0-9A-Fa-f]{2})*)(?::[0-9]*)?(?:\\/(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*|\\/(?:(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@]|%[0-9A-Fa-f]{2})+(?:\\/(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*)?|(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@]|%[0-9A-Fa-f]{2})+(?:\\/(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*|)(?:\\?(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@\\/?]|%[0-9A-Fa-f]{2})*)?(?:\\#(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@\\/?]|%[0-9A-Fa-f]{2})*)?|(?:\\/\\/(?:(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:]|%[0-9A-Fa-f]{2})*@)?(?:\\[(?:(?:(?:(?:[0-9A-Fa-f]{1,4}:){6}|::(?:[0-9A-Fa-f]{1,4}:){5}|(?:[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){4}|(?:(?:[0-9A-Fa-f]{1,4}:){0,1}[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){3}|(?:(?:[0-9A-Fa-f]{1,4}:){0,2}[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){2}|(?:(?:[0-9A-Fa-f]{1,4}:){0,3}[0-9A-Fa-f]{1,4})?::[0-9A-Fa-f]{1,4}:|(?:(?:[0-9A-Fa-f]{1,4}:){0,4}[0-9A-Fa-f]{1,4})?::)(?:[0-9A-Fa-f]{1,4}:[0-9A-Fa-f]{1,4}|(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))|(?:(?:[0-9A-Fa-f]{1,4}:){0,5}[0-9A-Fa-f]{1,4})?::[0-9A-Fa-f]{1,4}|(?:(?:[0-9A-Fa-f]{1,4}:){0,6}[0-9A-Fa-f]{1,4})?::)|[Vv][0-9A-Fa-f]+\\.[A-Za-z0-9\\-._~!$&\'()*+,;=:]+)\\]|(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|(?:[A-Za-z0-9\\-._~!$&\'()*+,;=]|%[0-9A-Fa-f]{2})*)(?::[0-9]*)?(?:\\/(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*|\\/(?:(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@]|%[0-9A-Fa-f]{2})+(?:\\/(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*)?|(?:[A-Za-z0-9\\-._~!$&\'()*+,;=@]|%[0-9A-Fa-f]{2})+(?:\\/(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*|)(?:\\?(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@\\/?]|%[0-9A-Fa-f]{2})*)?(?:\\#(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@\\/?]|%[0-9A-Fa-f]{2})*)?)$/i.test(', ')'], ['!/^(?:[A-Za-z][A-Za-z0-9+\\\\-.]*:(?:\\\\/\\\\/(?:(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:]|%[0-9A-Fa-f]{2})*@)?(?:\\\\[(?:(?:(?:(?:[0-9A-Fa-f]{1,4}:){6}|::(?:[0-9A-Fa-f]{1,4}:){5}|(?:[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){4}|(?:(?:[0-9A-Fa-f]{1,4}:){0,1}[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){3}|(?:(?:[0-9A-Fa-f]{1,4}:){0,2}[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){2}|(?:(?:[0-9A-Fa-f]{1,4}:){0,3}[0-9A-Fa-f]{1,4})?::[0-9A-Fa-f]{1,4}:|(?:(?:[0-9A-Fa-f]{1,4}:){0,4}[0-9A-Fa-f]{1,4})?::)(?:[0-9A-Fa-f]{1,4}:[0-9A-Fa-f]{1,4}|(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))|(?:(?:[0-9A-Fa-f]{1,4}:){0,5}[0-9A-Fa-f]{1,4})?::[0-9A-Fa-f]{1,4}|(?:(?:[0-9A-Fa-f]{1,4}:){0,6}[0-9A-Fa-f]{1,4})?::)|[Vv][0-9A-Fa-f]+\\\\.[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:]+)\\\\]|(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=]|%[0-9A-Fa-f]{2})*)(?::[0-9]*)?(?:\\\\/(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*|\\\\/(?:(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@]|%[0-9A-Fa-f]{2})+(?:\\\\/(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*)?|(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@]|%[0-9A-Fa-f]{2})+(?:\\\\/(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*|)(?:\\\\?(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@\\\\/?]|%[0-9A-Fa-f]{2})*)?(?:\\\\#(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@\\\\/?]|%[0-9A-Fa-f]{2})*)?|(?:\\\\/\\\\/(?:(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:]|%[0-9A-Fa-f]{2})*@)?(?:\\\\[(?:(?:(?:(?:[0-9A-Fa-f]{1,4}:){6}|::(?:[0-9A-Fa-f]{1,4}:){5}|(?:[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){4}|(?:(?:[0-9A-Fa-f]{1,4}:){0,1}[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){3}|(?:(?:[0-9A-Fa-f]{1,4}:){0,2}[0-9A-Fa-f]{1,4})?::(?:[0-9A-Fa-f]{1,4}:){2}|(?:(?:[0-9A-Fa-f]{1,4}:){0,3}[0-9A-Fa-f]{1,4})?::[0-9A-Fa-f]{1,4}:|(?:(?:[0-9A-Fa-f]{1,4}:){0,4}[0-9A-Fa-f]{1,4})?::)(?:[0-9A-Fa-f]{1,4}:[0-9A-Fa-f]{1,4}|(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))|(?:(?:[0-9A-Fa-f]{1,4}:){0,5}[0-9A-Fa-f]{1,4})?::[0-9A-Fa-f]{1,4}|(?:(?:[0-9A-Fa-f]{1,4}:){0,6}[0-9A-Fa-f]{1,4})?::)|[Vv][0-9A-Fa-f]+\\\\.[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:]+)\\\\]|(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=]|%[0-9A-Fa-f]{2})*)(?::[0-9]*)?(?:\\\\/(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*|\\\\/(?:(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@]|%[0-9A-Fa-f]{2})+(?:\\\\/(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*)?|(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=@]|%[0-9A-Fa-f]{2})+(?:\\\\/(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@]|%[0-9A-Fa-f]{2})*)*|)(?:\\\\?(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@\\\\/?]|%[0-9A-Fa-f]{2})*)?(?:\\\\#(?:[A-Za-z0-9\\\\-._~!$&\\\'()*+,;=:@\\\\/?]|%[0-9A-Fa-f]{2})*)?)$/i.test(', ')']),
    _templateObject17 = _taggedTemplateLiteral(['!/^(?:(?:[^\\x00-\\x20"\'<>%\\\\^`{|}]|%[0-9a-f]{2})|\\{[+#.\\/;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?:\\:[1-9][0-9]{0,3}|\\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?:\\:[1-9][0-9]{0,3}|\\*)?)*\\})*$/i.test(', ')'], ['!/^(?:(?:[^\\\\x00-\\\\x20"\\\'<>%\\\\\\\\^\\`{|}]|%[0-9a-f]{2})|\\\\{[+#.\\\\/;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?:\\\\:[1-9][0-9]{0,3}|\\\\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?:\\\\:[1-9][0-9]{0,3}|\\\\*)?)*\\\\})*$/i.test(', ')']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * @module formats
 * @description
 * Validators as string for format keyword rules.
 * A validator is a string, which when executed returns `false` if test is failed, `true` otherwise.
 */

var _require = __webpack_require__(2),
    expression = _require.expression;

module.exports = {
  alpha: expression(_templateObject, 'data'),
  alphanumeric: expression(_templateObject2, 'data'),
  identifier: expression(_templateObject3, 'data'),
  hexadecimal: expression(_templateObject4, 'data'),
  numeric: expression(_templateObject5, 'data'),
  'date-time': expression(_templateObject6, 'data', 'data'),
  uppercase: expression(_templateObject7, 'data', 'data'),
  lowercase: expression(_templateObject8, 'data', 'data'),
  hostname: expression(_templateObject9, 'data', 'data'),
  uri: expression(_templateObject10, 'data'),
  email: expression(_templateObject11, 'data'),
  ipv4: expression(_templateObject12, 'data', 'data'),
  ipv6: expression(_templateObject13, 'data'),
  regex: expression(_templateObject14, 'data'),
  // TODO optimize uri-reference regex... too long
  'json-pointer': expression(_templateObject15, 'data'),
  'uri-reference': expression(_templateObject16, 'data'),
  'uri-template': expression(_templateObject17, 'data')
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @module validators
 * @description
 * Contains validators functions links
 * Provides an information about the order in which validators should be applied
 * Each validator may return true, which means, others will be ignored
 * @see $ref
 */
var required = __webpack_require__(11);
var format = __webpack_require__(12);
var property = __webpack_require__(13);
var type = __webpack_require__(14);
var $ref = __webpack_require__(16);
var not = __webpack_require__(17);
var anyOf = __webpack_require__(18);
var oneOf = __webpack_require__(19);
var allOf = __webpack_require__(20);
var dependencies = __webpack_require__(21);
var properties = __webpack_require__(22);
var patternProperties = __webpack_require__(23);
var items = __webpack_require__(24);
var contains = __webpack_require__(25);
var constant = __webpack_require__(26);
var propertyNames = __webpack_require__(27);

module.exports = {
  name: {
    $ref: $ref,
    required: required,
    format: format,
    property: property,
    type: type,
    not: not,
    anyOf: anyOf,
    oneOf: oneOf,
    allOf: allOf,
    dependencies: dependencies,
    properties: properties,
    patternProperties: patternProperties,
    items: items,
    contains: contains,
    constant: constant,
    propertyNames: propertyNames
  },
  list: [$ref, required, format, property, type, not, anyOf, oneOf, allOf, dependencies, properties, patternProperties, items, contains, constant, propertyNames]
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module properties
 * @description
 * Validators as string for properties keyword rules.
 * A validator is a function, which when executed returns
 * - `false` if test is failed,
 * - `true` otherwise.
 */
module.exports = {
  readOnly: 'false',
  exclusiveMinimum: function exclusiveMinimum(schema) {
    return '%s <= ' + schema.exclusiveMinimum;
  },
  minimum: function minimum(schema) {
    return '%s < ' + schema.minimum;
  },
  exclusiveMaximum: function exclusiveMaximum(schema) {
    return '%s >= ' + schema.exclusiveMaximum;
  },
  maximum: function maximum(schema) {
    return '%s > ' + schema.maximum;
  },

  multipleOf: '($1/$2) % 1 !== 0 && typeof $1 === "number"',
  // When the instance value is a string
  // this provides a regular expression that a string instance MUST match in order to be valid.
  pattern: function pattern(schema) {
    var pattern = void 0;
    var modifiers = void 0;

    if (typeof schema.pattern === 'string') {
      pattern = schema.pattern;
    } else {
      pattern = schema.pattern[0];
      modifiers = schema.pattern[1];
    }

    var regex = new RegExp(pattern, modifiers);
    return 'typeof ($1) === "string" && !' + regex + '.test($1)';
  },

  /**
  * Creates an array containing the numeric code points of each Unicode
  * character in the string. While JavaScript uses UCS-2 internally,
  * this function will convert a pair of surrogate halves (each of which
  * UCS-2 exposes as separate characters) into a single code point,
  * matching UTF-16.
  * @see `punycode.ucs2.encode`
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode.ucs2
  * @name decode
  * @param {String} string The Unicode input string (UCS-2).
  * @returns {Array} The new array of code points.
  */
  minLength: 'typeof $1 === "string" && function dltml(b,c){for(var a=0,d=b.length;a<d&&c;){var e=b.charCodeAt(a++);55296<=e&&56319>=e&&a<d&&56320!==(b.charCodeAt(a++)&64512)&&a--;c--}return!!c}($1, $2)',
  maxLength: 'typeof $1 === "string" && function dmtml(b,c){for(var a=0,d=b.length;a<d&&0<=c;){var e=b.charCodeAt(a++);55296<=e&&56319>=e&&a<d&&56320!==(b.charCodeAt(a++)&64512)&&a--;c--}return 0>c}($1, $2)',
  // This attribute defines the minimum number of values
  // in an array when the array is the instance value.
  minItems: '$1.length < $2 && Array.isArray($1)',
  // This attribute defines the maximum number of values
  // in an array when the array is the instance value.
  maxItems: '$1.length > $2 && Array.isArray($1)',
  // TODO without some
  uniqueItems: function uniqueItems(schema, fn) {
    if (!schema.uniqueItems) {
      return 'true';
    }

    fn(fn.cache('{}'));
    return 'Array.isArray($1) && $1.some(function(item, key) {\n      if(item !== null && typeof item === "object") key = JSON.stringify(item);\n      else key = item;\n      if(' + fn.cache('{}') + '.hasOwnProperty(key)) return true;\n      ' + fn.cache('{}') + '[key] = true;\n    })';
  },

  // ***** object validation ****
  minProperties: '!Array.isArray($1) && typeof $1 === "object" && Object.keys($1).length < $2',
  // An object instance is valid against "maxProperties"
  // if its number of properties is less than, or equal to, the value of this keyword.
  maxProperties: '!Array.isArray($1) && typeof $1 === "object" && Object.keys($1).length > $2',
  // ****** all *****
  enum: function _enum(schema, fn) {
    return schema.enum.map(function (value) {
      var $1 = '$1';
      var comparedValue = value;

      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        comparedValue = '\'' + JSON.stringify(value) + '\'';
        $1 = fn.cache('JSON.stringify($1)');
      } else if (typeof value === 'string') {
        comparedValue = '\'' + escape(value) + '\'';
      }

      return $1 + ' != decodeURIComponent(' + comparedValue + ')';
    }).join(' && ');
  }
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @module keywords
 * @description
 * A list of keywords used in specification.
 */
module.exports = ['$ref', '$schema', 'type', 'not', 'anyOf', 'allOf', 'oneOf', 'properties', 'patternProperties', 'additionalProperties', 'items', 'additionalItems', 'required', 'default', 'title', 'description', 'definitions', 'dependencies', '$id', 'contains', 'const', 'examples'];

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @module utils
 * @description
 * Utilities to check and normalize uri
 */
var REGEXP_URI = /:\/\//;
var REGEXP_URI_FRAGMENT = /#\/?/;
var REGEXP_URI_PATH = /(^[^:]+:\/\/[^?#]*\/).*/;

/**
 * @name keys
 * @type {object}
 * @description
 * Keys to apply schema attributes & values
 */
var keys = {
  id: '$id'
};

/**
 * @name head
 * @type {function}
 * @description
 * Clean an id from its fragment
 * @example
 * head('http://domain.domain:2020/test/a#test')
 * // returns 'http://domain.domain:2020/test/a'
 * @param {string} id
 * @returns {string} cleaned
 */
function head(uri) {
  if (typeof uri !== 'string') {
    return uri;
  }

  var parts = uri.split(REGEXP_URI_FRAGMENT);
  return parts[0];
}

function isFullUri(uri) {
  return REGEXP_URI.test(uri);
}

/**
 * @name path
 * @type {function}
 * @description
 * Gets a scheme, domain and a path part from the uri
 * @example
 * path('http://domain.domain:2020/test/a?test')
 * // returns 'http://domain.domain:2020/test/'
 * @param {string} uri
 * @returns {string} path
 */
function path(uri) {
  return uri.replace(REGEXP_URI_PATH, '$1');
}

/**
 * @description
 * Get the fragment (#...) part of the uri
 * @see https://tools.ietf.org/html/rfc3986#section-3
 * @param {string} uri
 * @returns {string} fragment
 */
function fragment(uri) {
  if (typeof uri !== 'string') {
    return uri;
  }

  var parts = uri.split(REGEXP_URI_FRAGMENT);
  return parts[1];
}

/**
 * @name makePath
 * @type function
 * @description
 * Concat parts into single uri
 * @see https://tools.ietf.org/html/rfc3986#section-3
 * @param {array<string>} parts
 * @returns {string} uri
 */
function makePath(parts) {
  return parts.filter(function (part) {
    return typeof part === 'string';
  }).reduce(function (uri, id) {
    // if id is full replace uri
    if (!uri.length || isFullUri(id)) {
      return id;
    }
    if (!id) {
      return uri;
    }

    // if fragment found
    if (id.indexOf('#') === 0) {
      // should replace uri's sharp with id
      var sharpUriIndex = uri.indexOf('#');
      if (sharpUriIndex === -1) {
        return uri + id;
      }

      return uri.slice(0, sharpUriIndex) + id;
    }

    // get path part of uri
    // and replace the rest with id
    var partialUri = path(uri) + id;
    return partialUri + (partialUri.indexOf('#') === -1 ? '#' : '');
  }, '');
}

/**
 * @name normalize
 * @type {function}
 * @description
 * Replace json-pointer special symbols in a given uri.
 * @param {string} uri
 * @returns {string} normalizedUri
 */
function normalize(uri) {
  return decodeURIComponent(uri.replace(/~1/g, '/').replace(/~0/g, '~'));
}

module.exports = {
  makePath: makePath,
  isFullUri: isFullUri,
  head: head,
  fragment: fragment,
  normalize: normalize,
  keys: keys
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(9);


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = __webpack_require__(2),
    restore = _require.restore,
    expression = _require.expression;

var formats = __webpack_require__(3);

var _require2 = __webpack_require__(10),
    generate = _require2.generate,
    State = _require2.State;

var _require3 = __webpack_require__(28),
    add = _require3.add,
    use = _require3.use;

/**
 * Configuration for template
 * @typedef {object} DjvConfig
 * @property {string?} version - defines which version of json-schema draft to use,
 * draft-04 by default
 * @property {function?} versionConfigure - handler to apply for environment version
 * @property {boolean?} inner - a generating object should be considered as inner
 * Default value is false/undefined.
 * If true, then it avoid creating variables in a generated function body,
 * however without proper wrapper function approach will not work.
 * @see template/body, template/body
 * @property {object?} formats - an object containing list of formatters to add for environment
 * @property {function?} errorHandler - a handler to use for generating custom error messages
 */

/**
 * @name Environment
 * @description
 * Key constructor used for creating enivornment instance
 * @type {function} constructor
 * @param {DjvConfig} options passed to templater and utilities
 *
 * Usage
 *
 * ```javascript
 * const env = djv();
 * const env = new djv();
 * const env = new djv({ errorHandler: () => ';' });
 * ```
 */


function Environment() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!(this instanceof Environment)) {
    return new Environment(options);
  }

  this.options = options;
  this.resolved = {};
  this.state = new State(null, this);

  this.useVersion(options.version, options.versionConfigure);
  this.addFormat(options.formats);
}

Object.assign(Environment, {
  expression: expression
});

Object.assign(Environment.prototype, {
  /**
   * check if object correspond to schema
   *
   * Usage
   *
   * ```javascript
   * env.validate('test#/common', { type: 'common' });
   * // => undefined
   *
   * env.validate('test#/common', { type: 'custom' });
   * // => 'required: data'
   *
   * @param {string} name
   * @param {object} object
   * @returns {string} error - undefined if it is valid
   */
  validate: function validate(name, object) {
    var foundSchema = this.resolve(name);
    return foundSchema.fn(object);
  },


  /**
   * add schema to djv environment
   *
   * Usage
   *
   * ```javascript
   * env.addSchema('test', jsonSchema);
   * ```
   *
   * @param {string?} name
   * @param {object} schema
   * @param {object} schema
   * @returns {resolved}
   */
  addSchema: function addSchema(name, schema) {
    var _this = this;

    var realSchema = (typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object' ? name : schema;
    var resolved = {
      schema: realSchema,
      fn: generate(this, realSchema, undefined, this.options)
    };

    [name, schema.id].filter(function (id) {
      return typeof id === 'string';
    }).forEach(function (id) {
      _this.resolved[id] = Object.assign({ name: id }, resolved);
    });

    return resolved;
  },


  /**
   * removes a schema or the whole structure from djv environment
   *
   * Usage
   *
   * ```javascript
   * env.removeSchema('test');
   * ```
   *
   * @param {string} name
   */
  removeSchema: function removeSchema(name) {
    if (name) {
      delete this.resolved[name];
    } else {
      this.resolved = {};
    }
  },


  /**
   * resolves name by existing environment
   *
   * Usage
   *
   * ```javascript
   * env.resolve('test');
   * // => { name: 'test', schema: {} }, fn: ... }
   * ```
   *
   * @param {string} name
   * @returns {resolved}
   */
  resolve: function resolve(name) {
    if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object' || !this.resolved[name]) {
      return this.addSchema(name, this.state.resolve(name));
    }

    return this.resolved[name];
  },


  /**
   * exports the whole structure object from environment or by resolved name
   *
   * Usage
   *
   * ```javascript
   * env.export();
   * // => { test: { name: 'test', schema: {}, ... } }
   * ```
   *
   * @param {string} name
   * @returns {serializedInternalState}
   */
  export: function _export(name) {
    var _this2 = this;

    var resolved = void 0;
    if (name) {
      resolved = this.resolve(name);
      resolved = {
        name: name,
        schema: resolved.schema,
        fn: resolved.fn.toString()
      };
    } else {
      resolved = {};
      Object.keys(this.resolved).forEach(function (key) {
        resolved[key] = {
          name: key,
          schema: _this2.resolved[key].schema,
          fn: _this2.resolved[key].fn.toString()
        };
      });
    }

    return JSON.stringify(resolved);
  },


  /**
   * imports all found structure objects to internal environment structure
   * Usage
   *
   * ```javascript
   * env.import(config);
   * ```
   *
   * @param {object} config - internal structure or only resolved schema object
   */
  import: function _import(config) {
    var _this3 = this;

    var item = JSON.parse(config);
    var restoreData = item;
    if (item.name && item.fn && item.schema) {
      restoreData = _defineProperty({}, item.name, item);
    }

    Object.keys(restoreData).forEach(function (key) {
      var _restoreData$key = restoreData[key],
          name = _restoreData$key.name,
          schema = _restoreData$key.schema,
          source = _restoreData$key.fn;

      var fn = restore(source, schema, _this3.options);
      _this3.resolved[name] = { name: name, schema: schema, fn: fn };
    });
  },


  /**
   * @name addFormat
   * @type function
   * @description
   * Add formatter to djv environment.
   * When a string is passed it is interpreted as an expression which
   * when returns `true` goes with an error, when returns `false` then a property is valid.
   * When a function is passed it will be executed during schema compilation
   * with a current schema and template helper arguments.
   * @see utils/formats
   *
   * Usage
   *
   * ```javascript
   * env.addFormat('UpperCase', '%s !== %s.toUpperCase()');
   * // or
   * env.addFormat('isOk', function(schema, tpl){
   *   return `!${schema.isOk} || %s !== %s.toUpperCase()`;
   * });
   * ```
   *
   * @param {string/object?} name
   * @param {string/function} formatter
   */
  addFormat: function addFormat(name, formatter) {
    if (typeof name === 'string') {
      formats[name] = formatter;
      return;
    }

    if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
      Object.assign(formats, name);
    }
  },


  /**
   * @name setErrorHandler
   * @type function
   * @description
   * Specify custom error handler which will be used in generated functions when problem found.
   * The function should return a string expression, which will be executed when generated
   * validator function is executed. The simpliest use case is the default one
   * @see template/defaultErrorHandler
   * ```javascript
   *  function defaultErrorHandler(errorType) {
   *    return `return "${errorType}: ${tpl.data}";`;
   *  }
   * ```
   * It returns an expression 'return ...', so the output is an error string.
   * Usage
   * ```javascript
   * djv({ errorHandler: () => 'return { error: true };' }) // => returns an object
   * djv({
   *  errorHandler: function customErrorHandler(errorType, property) {
   *    return `errors.push({
   *      type: "${errorType}",
   *      schema: "${this.schema[this.schema.length - 1]}",
   *      data: "${this.data[this.data.length - 1]}"
   *    });`;
   *  }
   * });
   * ```
   * When a custom error handler is used, the template body function adds a `error` variable inside
   * a generated validator, which can be used to put error information. `errorType` is always
   * passed to error handler function. Some validate utilities put extra argument, like f.e.
   * currently processed property value. Inside the handler context is a templater instance,
   * which contains `this.schema`, `this.data` paths arrays to identify validator position.
   * @see test/index/setErrorHandler for more examples
   * @param {function} errorHandler - a function called each time compiler creates an error branch
   * @returns void
   */
  setErrorHandler: function setErrorHandler(errorHandler) {
    Object.assign(this.options, { errorHandler: errorHandler });
  },

  /**
  * @name useVersion
  * @type {function}
  * @description
  * Add a specification version for environment
  * A configure function is called with exposed environments, like keys, formats, etc.
  * Updates internals utilities and configurations to fix versions implementation conflicts
  * @param {string} version of json-schema specification to use
  * @param {function} configure
  * @returns void
  */
  useVersion: function useVersion(version, configure) {
    if (typeof configure !== 'function' && version === 'draft-04') {
      /* eslint-disable no-param-reassign, global-require, import/no-extraneous-dependencies */
      configure = __webpack_require__(29);
      /* eslint-enable no-param-reassign, global-require, import/no-extraneous-dependencies */
    }
    if (typeof configure === 'function') {
      add(version, configure);
    }
    use(version);
  }
});

module.exports = Environment;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @module state
 * @description
 * State module is responsible for scope schemas resolution.
 * It also exports a main `generate` function.
 */

var _require = __webpack_require__(4),
    validators = _require.list;

var _require2 = __webpack_require__(2),
    body = _require2.body,
    restore = _require2.restore,
    template = _require2.template;

var _require3 = __webpack_require__(0),
    hasProperty = _require3.hasProperty;

var _require4 = __webpack_require__(7),
    normalize = _require4.normalize,
    makePath = _require4.makePath,
    head = _require4.head,
    isFullUri = _require4.isFullUri,
    fragment = _require4.fragment,
    keys = _require4.keys;

var _require5 = __webpack_require__(1),
    isSchema = _require5.is,
    transformSchema = _require5.transform;

/* eslint-disable no-unused-vars */


function State() {
  var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var env = arguments[1];

  /* eslint-enable no-unused-vars */
  Object.assign(this, {
    context: [],
    entries: new Map(),
    env: env
  });
}

/**
 * @name generate
 * @type {function}
 * @description
 * The main schema process function.
 * Available and used both in external and internal generation.
 * Saves the state for internal recursive calls.
 * @param {object} env - djv environment
 * @param {object} schema - to process
 * @param {State} state - saved state
 * @param {Environment} options
 * @returns {function} restoredFunction
 */
function generate(env, schema) {
  var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new State(schema, env);
  var options = arguments[3];

  var tpl = template(state, options);
  tpl.visit(schema);

  var source = body(tpl, state, options);
  return restore(source, schema, options);
}

State.prototype = Object.assign(Object.create(Array.prototype), {
  /**
   * @name addEntry
   * @type {function}
   * @description
   * Generates an internal function.
   * Usually necessary for `allOf` types of validators.
   * Caches generated functions by schema object key.
   * Checks for an existing schema in a context stack to avoid double parsing and generation.
   * @param {string} url
   * @param {object} schema
   * @returns {number/boolean} index
   */
  addEntry: function addEntry(url, schema) {
    var entry = this.entries.get(schema);
    if (entry === false) {
      // has already been added to process queue
      // will be revealed as an entry
      return this.context.push(schema);
    }

    if (typeof entry === 'undefined') {
      // start to process schema
      this.entries.set(schema, false);
      entry = generate(this.env, schema, this, { inner: true });
      this.entries.set(schema, entry);
      this.revealReference(schema);
    }

    return this.context.push(entry);
  },

  /**
   * @name revealReference
   * @type {function}
   * @description
   * If a schema was added during the add entry phase
   * Then it should be revealed in this step
   * @param {object} schema
   * @returns {void}
   */
  revealReference: function revealReference(schema) {
    for (var doubled = this.context.indexOf(schema); doubled !== -1; doubled = this.context.indexOf(schema)) {
      this.context[doubled] = this.context.length;
    }
  },

  /**
   * @name link
   * @type {function}
   * @description
   * Returns an entry's index in a context stack.
   * @param {string} url
   * @returns {string} entry
   */
  link: function link(url) {
    var schema = this.resolve(url);
    var entry = this.addEntry(url, schema);
    return entry;
  },

  /**
   * @name resolveReference
   * @type {function}
   * @description
   * Resolve reference against the stack.
   * @param {string} reference
   * @returns {string} resolvedReference
   */
  resolveReference: function resolveReference(reference) {
    if (isFullUri(reference)) {
      return reference;
    }

    // find last full URI schema
    var lastFullURIReference = void 0;
    var lastFullURISchemaIndex = void 0;

    for (var i = this.length - 1; i >= 0; i -= 1, lastFullURIReference = false) {
      var _i = this[i],
          id = _i[keys.id],
          $ref = _i.$ref;

      lastFullURIReference = id || $ref;
      if (isFullUri(lastFullURIReference)) {
        lastFullURISchemaIndex = i;
        break;
      }
    }

    // collect all partial routes for it
    var partialReferences = [];
    for (var _i2 = this.length - 1; _i2 > lastFullURISchemaIndex; _i2 -= 1) {
      var _i3 = this[_i2],
          _id = _i3[keys.id],
          _$ref = _i3.$ref;

      var partialReference = _id || _$ref;
      if (head(partialReference)) {
        partialReferences.push(partialReference);
      }
    }

    // attach reference and make path
    var path = makePath([lastFullURIReference].concat(partialReferences, [reference]));
    return path;
  },

  /**
   * @name ascend
   * @private
   * @type {function}
   * @description
   * Search for a parent schema by reference.
   * Iterates over the chain of schemas.
   * @param {string} reference
   * @returns {object} parentSchema
   */
  ascend: function ascend(reference) {
    var path = head(reference);

    var _ref = this.env.resolved[path] || {},
        _ref$schema = _ref.schema,
        parentSchema = _ref$schema === undefined ? this[0] : _ref$schema;

    // Search while it is a full schema, not a ref


    while (parentSchema.$ref &&
    // avoid infinite loop
    head(parentSchema.$ref) !== head(reference) &&
    // > All other properties in a "$ref" object MUST be ignored.
    // @see https://tools.ietf.org/html/draft-wright-json-schema-01#section-8
    Object.keys(parentSchema).length === 1) {
      parentSchema = this.ascend(parentSchema.$ref);
    }

    return parentSchema;
  },

  /**
   * @name descend
   * @private
   * @type {function}
   * @description
   * Search for a child schema by reference.
   * Iterates over the chain of schemas.
   * @param {string} reference
   * @returns {object} currentSchema
   */
  descend: function descend(reference, parentSchema) {
    var _this = this;

    var uriFragment = fragment(reference);
    if (!uriFragment && isFullUri(reference)) {
      return parentSchema;
    }

    if (!uriFragment) {
      uriFragment = reference;
    }

    var parts = uriFragment.split('/');
    var currentSchema = parts.map(normalize).reduce(function (schema, part, index) {
      var subSchema = schema[part];
      if (!isSchema(subSchema)) {
        subSchema = schema.definitions && schema.definitions[part];
      }

      if (
      // last will be pushed on visit
      // @see /draft4/refRemote.json:http://localhost:1234/scope_change_defs2.json
      index !== parts.length - 1 && hasProperty(subSchema, keys.id)) {
        _this.push(subSchema);
      }

      return subSchema;
    }, parentSchema);

    return isSchema(currentSchema) ? currentSchema : parentSchema;
  },

  /**
   * @name resolve
   * @type {function}
   * @description
   * Resolves schema by given reference and current registered context stack.
   * @param {string} url
   * @returns {object} schema
   */
  resolve: function resolve(reference) {
    if (typeof reference !== 'string') {
      return reference;
    }

    var fullReference = this.resolveReference(reference);
    var parentSchema = this.ascend(fullReference);
    var subSchema = this.descend(reference, parentSchema);

    return subSchema;
  },

  /**
   * @name visit
   * @type {function}
   * @description
   * Calls each registered validator with given schema and template instance.
   * Validator may or may not add code to generated validator function.
   * @param {object} pseudoSchema
   * @param {object} tpl
   * @returns {void}
   */
  visit: function visit(pseudoSchema, tpl) {
    var schema = transformSchema(pseudoSchema);
    var initialLength = this.length;
    this.push(schema);

    validators.some(function (validator) {
      return validator(schema, tpl);
    });

    this.length = initialLength;
  }
});

module.exports = {
  State: State,
  generate: generate
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function required(schema, tpl) {
  if (!Array.isArray(schema.required)) {
    return;
  }

  tpl('if (' + tpl.data + ' !== null && typeof ' + tpl.data + ' === \'object\' && !Array.isArray(' + tpl.data + ')) {\n    ' + schema.required.map(function (name) {
    var condition = '!' + tpl.data + '.hasOwnProperty(decodeURIComponent("' + escape(name) + '"))';
    var error = tpl.error('required', name);
    return 'if (' + condition + ') ' + error;
  }).join('') + '\n  }');
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(3);

module.exports = function format(schema, tpl) {
  if (typeof schema.format === 'undefined') {
    return;
  }

  var formatter = formats[schema.format];
  if (typeof formatter !== 'function') {
    return;
  }

  var data = tpl.data;

  var condition = formatter({ data: data, schema: schema });
  var error = tpl.error('format');

  tpl('if (' + condition + ') ' + error);
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var properties = __webpack_require__(5);
var keywords = __webpack_require__(6);

var _require = __webpack_require__(0),
    asExpression = _require.asExpression;

module.exports = function property(schema, tpl) {
  Object.keys(schema).forEach(function (key) {
    if (keywords.indexOf(key) !== -1 || key === 'format') {
      return;
    }

    var condition = asExpression(properties[key], schema, tpl);
    if (!condition) {
      return;
    }
    var error = tpl.error(key);

    tpl('if (' + condition + ') ' + error, tpl.data, schema[key]);
  });
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var types = __webpack_require__(15);

var _require = __webpack_require__(0),
    hasProperty = _require.hasProperty;

module.exports = function type(schema, tpl) {
  if (!hasProperty(schema, 'type')) {
    return;
  }

  var error = tpl.error('type', schema.type);
  var condition = '(' + [].concat(schema.type).map(function (key) {
    return types[key];
  }).join(') && (') + ')';

  tpl('if (' + condition + ') ' + error, tpl.data);
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  null: '%s !== null',
  string: 'typeof %s !== "string"',
  boolean: 'typeof %s !== "boolean"',
  number: 'typeof %s !== "number" || %s !== %s',
  integer: 'typeof %s !== "number" || %s % 1 !== 0',
  object: '!%s || typeof %s !== "object" || Array.isArray(%s)',
  array: '!Array.isArray(%s)',
  date: '!(%s instanceof Date)'
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    hasProperty = _require.hasProperty;

module.exports = function $ref(schema, tpl) {
  if (!hasProperty(schema, '$ref')) {
    return false;
  }

  var condition = tpl.link(schema.$ref) + '(' + tpl.data + ')';
  var error = tpl.error('$ref');

  tpl('if (' + condition + ') ' + error);

  // All other properties in a "$ref" object MUST be ignored.
  // @see https://tools.ietf.org/html/draft-wright-json-schema-01#section-8
  return true;
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    hasProperty = _require.hasProperty;

module.exports = function not(schema, tpl) {
  if (!hasProperty(schema, 'not')) {
    return;
  }

  var condition = tpl.link(schema.not) + '(' + tpl.data + ')';
  var error = tpl.error('not');

  tpl('if (!' + condition + ') ' + error);
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    hasProperty = _require.hasProperty;

module.exports = function anyOf(schema, tpl) {
  if (!hasProperty(schema, 'anyOf')) {
    return;
  }

  var error = tpl.error('anyOf');
  var condition = schema.anyOf.map(function (reference) {
    return tpl.link(reference) + '(' + tpl.data + ')';
  }).join(' && ');

  tpl('if (' + condition + ') ' + error);
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    hasProperty = _require.hasProperty;

module.exports = function oneOf(schema, tpl) {
  if (!hasProperty(schema, 'oneOf')) {
    return;
  }

  var fns = schema.oneOf.map(function (reference) {
    return tpl.link(reference);
  });
  var arr = tpl.cache('[' + fns + ']');
  var cachedArr = tpl.cache('[' + fns + ']');
  var index = tpl.cache(cachedArr + '.length - 1');
  var cachedIndex = tpl.cache(cachedArr + '.length - 1');
  var count = tpl.cache('0');
  var cachedCount = tpl.cache('0');
  var error = tpl.error('oneOf');

  tpl('for (\n    ' + arr + ', ' + index + ', ' + count + ';\n    ' + cachedIndex + ' >= 0 && ' + cachedIndex + ' < ' + cachedArr + '.length;\n    ' + cachedIndex + '--) {\n      if(!' + cachedArr + '[' + cachedIndex + '](' + tpl.data + ')) ' + cachedCount + '++;\n    }\n    if (' + cachedCount + ' !== 1) ' + error + '\n  ');
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    hasProperty = _require.hasProperty;

module.exports = function allOf(schema, tpl) {
  if (!hasProperty(schema, 'allOf')) {
    return;
  }

  var error = tpl.error('allOf');
  var condition = schema.allOf.map(function (reference) {
    return tpl.link(reference) + '(' + tpl.data + ')';
  }).join(' || ');

  tpl('if (' + condition + ') ' + error);
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _require = __webpack_require__(0),
    hasProperty = _require.hasProperty;

var _require2 = __webpack_require__(1),
    isSchema = _require2.is;

// @see http://json-schema.org/latest/json-schema-validation.html#rfc.section.6.5.7


module.exports = function dependencies(schema, tpl) {
  if (!hasProperty(schema, 'dependencies')) {
    return;
  }

  Object.keys(schema.dependencies).forEach(function (dependency) {
    var value = schema.dependencies[dependency];
    var error = tpl.error('dependencies');

    tpl('if (' + tpl.data + '.hasOwnProperty(decodeURIComponent("' + escape(dependency) + '"))) {');
    if (Array.isArray(value) || typeof value === 'string') {
      [].concat(_toConsumableArray(value)).map(function (property) {
        return 'if (!' + tpl.data + '.hasOwnProperty(decodeURIComponent("' + escape(property) + '"))) ' + error;
      }).map(tpl);
    } else if (isSchema(value)) {
      tpl.visit(value);
    }
    tpl('}');
  });
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _require = __webpack_require__(0),
    hasProperty = _require.hasProperty;

module.exports = function properties(schema, tpl) {
  if (!hasProperty(schema, 'properties') || _typeof(schema.properties) !== 'object') {
    return;
  }

  Object.keys(schema.properties).forEach(function (propertyKey) {
    var propertySchema = schema.properties[propertyKey];
    if ((typeof propertySchema === 'undefined' ? 'undefined' : _typeof(propertySchema)) === 'object' && !Object.keys(propertySchema).length) {
      return;
    }

    var isNotRequired = !schema.required || schema.required.indexOf(propertyKey) === -1;
    if (isNotRequired) {
      tpl('if (' + tpl.data + '.hasOwnProperty(decodeURIComponent("' + escape(propertyKey) + '"))) {');
    }

    tpl.data.push('[decodeURIComponent(\'' + escape(propertyKey) + '\')]');
    tpl.visit(propertySchema);
    tpl.data.pop();

    if (isNotRequired) {
      tpl('}');
    }
  });
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    hasProperty = _require.hasProperty;

module.exports = function patternProperties(schema, tpl) {
  var hasAdditionalProperties = hasProperty(schema, 'additionalProperties') && schema.additionalProperties !== true;
  var hasPatternProperties = hasProperty(schema, 'patternProperties');

  if (!hasAdditionalProperties && !hasPatternProperties) {
    return;
  }

  // When the instance value is an object,
  // the property values of the instance object
  // MUST conform to the property definitions in this object.
  tpl('if(typeof ' + tpl.data + ' === \'object\' && !Array.isArray(' + tpl.data + ')) {');

  tpl(tpl.cache('null'));
  var property = tpl.cache('null');
  var visitAdditionalProperties = function visitAdditionalProperties() {
    if (schema.additionalProperties === false) {
      tpl(tpl.error('additionalProperties'));
    } else if (schema.additionalProperties) {
      tpl.data.push('[' + property + ']');
      tpl.visit(schema.additionalProperties);
      tpl.data.pop();
    }
  };

  tpl('for (' + property + ' in ' + tpl.data + ') {');
  if (hasAdditionalProperties && hasPatternProperties) {
    tpl(tpl.cache('false'));
  }

  if (hasPatternProperties) {
    Object.keys(schema.patternProperties).forEach(function (propertyKey) {
      tpl('if (' + new RegExp(propertyKey) + '.test(' + property + ')) {');
      if (hasAdditionalProperties) {
        tpl(tpl.cache('false') + ' = true;');
      }

      var propertySchema = schema.patternProperties[propertyKey];
      tpl.data.push('[' + property + ']');
      tpl.visit(propertySchema);
      tpl.data.pop();
      tpl('}');

      if (schema.properties) {
        tpl('if (' + (hasAdditionalProperties ? tpl.cache('false') + ' || ' : '') + ' ' + tpl.schema + '.properties.hasOwnProperty(' + property + ')) continue;');
      } else if (hasAdditionalProperties) {
        tpl('if (' + tpl.cache('false') + ') continue;');
      }

      visitAdditionalProperties();
    });
  } else {
    if (schema.properties) {
      tpl('if(' + tpl.schema + '.properties.hasOwnProperty(' + property + ')) continue;');
    }
    visitAdditionalProperties();
  }

  tpl('}}');
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _require = __webpack_require__(0),
    hasProperty = _require.hasProperty;

module.exports = function items(schema, tpl) {
  if (!hasProperty(schema, 'items')) {
    return;
  }

  var itemsLength = schema.items.length;
  var error = tpl.error('additionalItems');
  var data = tpl.data;


  tpl('if(Array.isArray(' + data + ')) {');
  if (Array.isArray(schema.items)) {
    if (schema.additionalItems === false) {
      tpl('if (' + data + '.length > ' + itemsLength + ') ' + error);
    }

    schema.items.forEach(function (subSchema, index) {
      tpl('if(' + data + '.length > ' + index + ') {');
      data.push('[' + index + ']');
      tpl.visit(subSchema);
      data.pop();
      tpl('}');
    });

    if (_typeof(schema.additionalItems) === 'object') {
      var zeroIndex = tpl.cache(itemsLength);
      var index = tpl.cache(itemsLength);

      tpl('for (' + zeroIndex + '; ' + index + ' < ' + data + '.length; ' + index + '++) {');
      data.push('[' + tpl.cache(itemsLength) + ']');
      tpl.visit(schema.additionalItems);
      data.pop();
      tpl('}');
    }
  } else {
    var _zeroIndex = tpl.cache('0');
    var _index = tpl.cache('0');

    tpl('for (' + _zeroIndex + '; ' + _index + ' < ' + data + '.length; ' + _index + '++) {');
    data.push('[' + _index + ']');
    tpl.visit(schema.items);
    data.pop();
    tpl('}');
  }
  tpl('}');
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    hasProperty = _require.hasProperty;

module.exports = function contains(schema, tpl) {
  if (!hasProperty(schema, 'contains')) {
    return;
  }

  var error = tpl.error('contains');
  var fn = '' + tpl.link(schema.contains);

  var data = tpl.data;

  var zeroIndex = tpl.cache('0');
  var index = tpl.cache('0');
  var dataAtIndex = data.toString.apply(data.concat('[' + index + ']'));

  tpl('if (Array.isArray(' + data + ')) {\n    if (' + data + '.length === 0) ' + error + '\n      for (' + zeroIndex + '; ' + index + ' < ' + data + '.length; ' + index + '++) {\n        if (!' + fn + '(' + dataAtIndex + ')) break;\n        if (' + index + ' === ' + data + '.length - 1) ' + error + '\n      }\n  }');
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    hasProperty = _require.hasProperty;

var _require2 = __webpack_require__(1),
    makeSchema = _require2.make;

module.exports = function constant(schema, tpl) {
  if (!hasProperty(schema, 'const')) {
    return;
  }

  var constantInstanceSchema = makeSchema(schema.const);
  tpl.visit(constantInstanceSchema);
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    hasProperty = _require.hasProperty;

module.exports = function propertyNames(schema, tpl) {
  if (!hasProperty(schema, 'propertyNames')) {
    return;
  }

  var fn = tpl.link(schema.propertyNames);
  var error = tpl.error('propertyNames');

  tpl('if (Object.keys(' + tpl.data + ').some(' + fn + ')) ' + error);
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @module environment
 * @description
 * Update the given environment
 */
var properties = __webpack_require__(5);
var keywords = __webpack_require__(6);
var validators = __webpack_require__(4);
var formats = __webpack_require__(3);

var _require = __webpack_require__(7),
    keys = _require.keys;

var _require2 = __webpack_require__(1),
    transformation = _require2.transformation;

var environmentConfig = {};

function add(version, config) {
  environmentConfig[version] = config;
}

function use(version) {
  if (!version || !environmentConfig[version]) {
    return;
  }

  var patchEnvironment = environmentConfig[version];
  patchEnvironment({
    properties: properties,
    keywords: keywords,
    validators: validators,
    formats: formats,
    keys: keys,
    transformation: transformation
  });
}

module.exports = {
  add: add,
  use: use
};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_29__;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// djv.js